// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__9qnGG","image":"styles_image__9sPe1"};